import * as React from 'react';

function SoundOn(props) {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m27.848 11-.811.87c2.092 2.083 3.2 4.598 3.2 7.559.001 2.968-1.101 5.493-3.2 7.578l.815.875c4.912-4.632 4.656-12.608-.004-16.882Zm-2.075 2.292-.8.853c1.472 1.482 2.252 3.229 2.252 5.3 0 2.08-.79 3.833-2.252 5.3l.817.865c3.745-3.558 3.298-9.389-.017-12.318Zm-2.857 3.046.79-.84c2.1 1.73 2.478 5.64.019 7.894l-.811-.857c.854-.866 1.316-1.891 1.313-3.11-.003-1.209-.468-2.223-1.311-3.087ZM20 11.823a.506.506 0 0 0-.82-.403l-7.037 5.51H8.508a.51.51 0 0 0-.508.51v5.425c0 .283.227.511.508.511h3.627l7.034 5.82a.506.506 0 0 0 .831-.394v-16.98Zm-7.37 6.02 6.354-4.975V27.72l-6.344-5.249a.506.506 0 0 0-.322-.116H9.016V17.95h3.302a.506.506 0 0 0 .312-.108Z"
            fill="#000"
            />
        </svg>
    );
}

export default SoundOn;
